var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "aftersale-detail" },
    [
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: { data: _vm.aftersaleDetailTableData, border: "" }
        },
        [
          _c("el-table-column", {
            attrs: { type: "index", label: "序号", width: "50" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "created_at", label: "日期", width: "120" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "as_number", label: "服务编号", width: "130" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "order_number", label: "订单号", width: "120" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "user_name", label: "客户" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "user_address", label: "地址", width: "150" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "applied_num", label: "申请数量" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "received_num", label: "入库数量" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "accepted_num", label: "出库数量" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "abnormal", label: "异常原因" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "send_amount", label: "责任方" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "as_statusName", label: "售后状态" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "as_typeName", label: "售后类型" }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-07f317ee", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07f317ee","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/bigAftersale/abnormal-detail.vue
// module id = null
// module chunks = 